
<Popup
  :visible="visible"
  position="bottom"
  :overlay="false"
  :class="classes(
    n(),
  )
  "
>
  <div
    :class="classes(n('--container'))"
    @touchstart="handleContainerClick"
    @click="handleContainerClick"
  >
    <div
      v-if="closeBtnText"
      :class="classes(n('--header'))"
    >
      <span
        :class="classes(n('--header--close-btn'))"
        @click="emit('close')"
      >{{ closeBtnText }}</span>
    </div>
    <DefaultKeyboard
      v-if="type === 'default'"
      v-bind="$props"
      @click="handleKeyboardClick"
    />
    <ConfirmKeyboard
      v-else
      v-bind="$props"
      @click="handleKeyboardClick"
    />
  </div>
</Popup>
